import { FC, useState } from 'react';
import { b64EncodeUnicode } from '@/_helpers/all';

import Share from '../../../tour/regular/share/Share';
import { Props } from './types';
import {
  Root,
  Title,
  Icon,
  ButtonGroup,
  Button,
  BackgroundFilter,
  IconAndText,
  Divider,
} from '../FinishScreen/styled';
import { getVersion } from '@/components/util';
import { StarRating } from '../FinishScreen/components/StarRating/StarRating';

export const SimpleFinishScreen: FC<Props & { children?: any }> = ({
  game,
  username,
  tour,
  translation,
  sendRating,
}) => {
  const [showSubmitRateBtn, setShowSubmitRateBtn] = useState<boolean>(!!sendRating);
  const [rating, setRating] = useState(0);
  const [showSharePopup, setShowSharePopup] = useState<boolean>(false);

  const handleShare = () => setShowSharePopup(true);

  const handleSubmitRating = () => {
    if (rating) {
      sendRating(rating);
      setShowSubmitRateBtn(false);
    }
  };

  const backgroundImagePath = tour.introScreen.backgroundImage
    ? `${process.env.NEXT_PUBLIC_CDN}/tours/${tour.id}/images/${
        tour.introScreen.backgroundImage
      }${getVersion(tour.updatedAt)}`
    : `${process.env.NEXT_PUBLIC_CDN}/tours/${tour.id}/images/${tour.mainImage}${getVersion(
        tour.updatedAt,
      )}`;

  const gameDataEncoded = b64EncodeUnicode([username].join());
  const shareLink = `${location.origin}/experience/${game.id}/${tour.slug}/${gameDataEncoded}`;
  return (
    <Root backgroundImage={backgroundImagePath}>
      <BackgroundFilter>
        <div className="d-flex flex-column justify-content-center align-items-center col-md-6 offset-md-3 pt-5">
          <Icon />
          <Title>{game.finishScreenTitle || translation.congratulations}</Title>
          <ButtonGroup show={game.finishScreenShareOn}>
            <Button show={game.finishScreenShareOn} onClick={handleShare}>
              <IconAndText
                show
                src="/experience/finishScreen/share.svg"
                text={translation.shareExperienceTour}
              />
            </Button>
          </ButtonGroup>

          {game.finishScreenRateOn && (
            <>
              <Divider />
              <div className="d-flex justify-content-center align-items-center my-4">
                <p>{translation?.howWasExperience || 'How was your experience?'}</p>
                <p className="mr-2" />
                <StarRating canEdit={showSubmitRateBtn} onChange={(value) => setRating(value)} />
                <p className="mr-2" />
                <Button show={showSubmitRateBtn} onClick={handleSubmitRating}>
                  <p>{translation?.submit || 'Submit'}</p>
                </Button>
              </div>
            </>
          )}

          {showSharePopup && (
            <Share
              onClose={() => setShowSharePopup(false)}
              link={shareLink}
              hideShareLocation
              translation={translation}
            />
          )}
        </div>
      </BackgroundFilter>
    </Root>
  );
};
